import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { TextInput, Button } from "flowbite-react";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechaMedicaInterface } from "../../../../../interfaces/FechaMedicaInterface";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const AutorizacionMEditarScreen = () => {
  const {isDarkMode} = useContext(ThemeContext);
  const tituloFormulario = "AUTORIZACIÓN AL PROCESO DE EVALUACIONES MÉDICAS";
  const [formData, setFormData] = useState({
    date: "",
  });

  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const { control, handleSubmit, setValue, reset } = useForm();

  const queryFechaM = useGetData<FechaMedicaInterface[]>({
    url: `/fecha-medica/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fecha-medica"],
  });

  const mutateFechaM = useMutationData({
    url: `/fecha-medica/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "fecha-medica"],
  });

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (queryFechaM.data && queryFechaM.data.length > 0) {
      const fecham = queryFechaM.data[0];
      reset({
        fecha_autorizacionm: fecham.fecha_autorizacionm || "",
      });
    }
  }, [queryFechaM.data, reset]);

  const navigate = useNavigate();

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className="container mx-auto p-4">
        <form
          onSubmit={handleSubmit((data) => {
            console.log(data);

            // Aseguramos que los valores seleccionados se incluyan
            const formData = {
              ...data,
            };

            // Mutación para guardar la Fecha de Detección de Riesgos
            mutateFechaM.mutate(
              {
                data: { fecha_autorizacionm: data.fecha_autorizacionm },
                tipo: "put",
              },
              {
                onSuccess: () => {
                  navigate(`/medica/${evaluadosList_id}`);
                },
                onError: (error) => {
                  console.error("Error al guardar Fecha Médica:", error);
                },
              }
            );
          })}
          className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800" : "bg-white"}`}
        >
          {/* Header */}
          <Header titulo={tituloFormulario}/>

          {/* Contenido del formulario */}
          <div className="p-6">
            <div className="text-center mb-8">
              <div className="flex justify-left items-center gap-2 mb-4">
                <p className={`mt-3 ${isDarkMode ? "text-gray-300" : "text-black"}`}>Ciudad de México a</p>
                <Controller
                  name="fecha_autorizacionm"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      id="fecha_autorizacionm"
                      type="date"
                      value={
                        field.value ||
                        (queryFechaM.data && queryFechaM.data.length > 0
                          ? queryFechaM.data[0]?.fecha_autorizacionm || ""
                          : "")
                      }
                      onChange={(e) => field.onChange(e.target.value)}
                      className={`text-center w-full ${isDarkMode ? "bg-gray-700 border-gray-600 text-gray-300" : "bg-white border-gray-300 text-gray-800"}`}
                    />
                  )}
                />
              </div>
              <h2 className={`text-xl font-bold mb-4 flex justify-center items-center ${isDarkMode ? "text-white" : "text-black"}`}>
                AUTORIZACIÓN AL PROCESO DE EVALUACIONES MÉDICAS
              </h2>
            </div>

            <div className="space-y-6">
              <div className="flex items-start">
                <span className={`mr-2 ${isDarkMode ? "text-gray-300" : "text-black"}`}>Yo</span>
                <TextInput
                  type="text"
                  name="name"
                  value={`${queryEvaluado.data?.nombre || ""} ${
                    queryEvaluado.data?.apellido_paterno || ""
                  } ${queryEvaluado.data?.apellido_materno || ""}`}
                  disabled={true}
                  onChange={handleInputChange}
                  className={`flex-1 mx-2 ${isDarkMode ? "bg-gray-700 border-gray-600 text-gray-300" : "bg-gray-100 border-gray-300 text-gray-800"}`}
                />
                <span className={`ml-2 ${isDarkMode ? "text-gray-300" : "text-black"}`}>
                  , autorizo que se me apliquen todas las evaluaciones Medicas
                </span>
              </div>
              <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-black"}`}>
                que consisten en revisión, valoración, cuestionarios, exploración
                física, entrevista, etc. Asimismo, autorizo a la empresa SKA
                TRACKING AND SECURITY S.A. de C.V. para que proporcione toda la
                información que se refiere a mi estado de salud, inclusive todos
                los datos y enfermedades anteriores, así como toda la información
                y documentación que derive de las evaluaciones de pruebas de
                confianza que me realicen.
              </p>
              <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-black"}`}>
                En este acto autorizo y conozco el aviso de privacidad el cual se
                encuentra publicado en
                https://skyangel.com.mx/avisodeprivacidad.htlm, por lo cual en
                este acto consiento que SKA TRACKING AND SECURITY S.A. de C.V.
                podrá recabar mis datos personales de conformidad con los términos
                establecidos en dicho aviso.
              </p>

              <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-black"}`}>
                Bajo protesta de decir verdad hago constar que los datos
                proporcionados en el proceso de evaluación son verdaderos.
              </p>

              <div className="mt-12 text-center">
                <p className={`mb-8 font-bold ${isDarkMode ? "text-white" : "text-black"}`}>ATENTAMENTE</p>
                <div className="w-64 mx-auto border-t border-black pt-2">
                  <p className={`text-sm ${isDarkMode ? "text-gray-300" : "text-black"}`}>NOMBRE Y FIRMA</p>
                </div>
              </div>
            </div>
          </div>

          {/* Botones */}
          <div className="mt-4 mb-4 px-4">
            <div className="flex justify-between">
              <Button
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(-1);
                }}
                className={`ml-2 ${isDarkMode ? "bg-red-600 hover:bg-red-800 text-white" : "bg-red-500 text-white"}`}
              >
                Regresar
              </Button>
              <Button
                type="submit"
                className={`ml-2 ${isDarkMode ? "bg-green-600 hover:bg-green-800 text-white" : "bg-green-500 hover:bg-green-600 text-white"}`}
              >
                {" "}
                Guardar{" "}
              </Button>
            </div>
          </div>

          {/* Footer */}
          <div className={`h-12 mt-8 flex items-center justify-center ${isDarkMode ? "bg-blue-700" : "bg-customBlue"}`}>
            <p className="text-sm text-white px-4">
              <span className="font-bold">DOCUMENTO CONFIDENCIAL</span>, prohibido
              su reproducción, copia o sacar este documento de las Instalaciones
              de Skyangel
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};
